export default "__VITE_ASSET__A_qUYiu___"